import { render, staticRenderFns } from "./EditBag.vue?vue&type=template&id=31fccbed"
import script from "./EditBag.vue?vue&type=script&lang=js"
export * from "./EditBag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports